import {
  IFirstPasswordChangeAdminRequest,
  IFirstPasswordChangeRequest,
  IPasswordChangeRequest,
} from "models/Password/password.model";

export const requestDataDefaultValues: IFirstPasswordChangeAdminRequest = {
  newPassword: "",
  newPasswordAgain: "",
};

export const requestDataChangeDefaultValues: IPasswordChangeRequest = {
  oldPassword: "",
  newPassword: "",
  newPasswordAgain: "",
};

export const requestDataFirstChange: IFirstPasswordChangeRequest = {
  newPassword: "",
  newPasswordAgain: "",
};
